import Vue from 'vue'
import bulletinNotify from './notify'

const notify = Vue.extend(bulletinNotify)

let notifyArr = []
let notifyWrap = document.createElement('div')
notifyWrap.className = "bulletin-notify-wrap"
document.body.appendChild(notifyWrap)

let message = {
  notify: ({ info, title, type, time=3000, callback=()=>{} }) => {
    const notifyDom = new notify({
      el: document.createElement('div'),
      data() {
        return {
          notifyFlag: true, // 是否显示
          timeFlag: false,
          title: title,
          type: type,
          timer: '',
          time: time,
          callback: callback,
          info: info
        }
      },
      watch: {
        timeFlag() {
          if (this.timeFlag) {
            this.notifyFlag = false
            window.clearTimeout(this.timer) 
          }
        }
      },
      created() {
        this.timer = setTimeout(() => { 
          this.timeFlag = true
        }, this.time)
      },
      beforeDestroy() {
        window.clearTimeout(this.timer)
      },
      methods: {
        handleClose() {
          this.notifyFlag = false
        },
        handleUndo() {
          this.callback(this.info)
          window.clearTimeout(this.timer)
        }
      }
    })
    notifyWrap.appendChild(notifyDom.$el)
    notifyArr.unshift(notifyDom)
    if (notifyArr.length > 5) {
      let arr = notifyArr.splice(5)
      arr.map(item => item.handleClose())
    }
    return notifyDom
  }
}

//注册
function register() {
  Vue.prototype.$bulletinNotify = message
}

export default {
  message,
  register
}
